import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAdminAuth } from '../context/AdminAuthContext';

const ProtectedAdminRoute = ({ children }) => {
    const { isAdmin, checkingAuth } = useAdminAuth();

    if (checkingAuth) {
        return <div style={{ padding: 40, textAlign: 'center' }}>Loading...</div>;
    }

    if (!isAdmin) {
        return <Navigate to="/admin/login" replace />;
    }

    return children;
};

export default ProtectedAdminRoute;
